import React from 'react';
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Button,
  NavLink,
  Accordion,
  AccordionItem,
  AccordionHeader,
  AccordionBody,
} from 'reactstrap';

interface PricingSectionProps {
  openAccordion: string;
  toggleAccordion: (id: string) => void;
}

const PricingSection: React.FC<PricingSectionProps> = ({ openAccordion, toggleAccordion }) => {
  return (
    <section className="pricing-section py-5" id="pricing">
      <Container>
        <h2 className="text-center mb-5 fw-bold fs-2">Flexible Plans for Your Business</h2>
        <Row>
          <Col md={4}>
            <Card className="pricing-card">
              <CardBody>
                <h3>Basic</h3>
                <p className="fs-2 fw-bold">
                  $49<span className="fs-5 fw-normal">/month</span>
                </p>
                <ul className="list-unstyled">
                  <li>Tenant Management</li>
                  <li>Basic Notifications</li>
                  <li>Email Support</li>
                  <li>Up to 5 Tenants</li>
                  <li>Basic Role Permissions</li>
                </ul>
                <Button color="primary" size="lg" className="mt-4">
                  <NavLink href="#tenant-request" className="text-white text-decoration-none">
                    Get Started
                  </NavLink>
                </Button>
              </CardBody>
            </Card>
          </Col>
          <Col md={4}>
            <Card className="pricing-card popular">
              <CardBody>
                <div className="popular-badge">Most Popular</div>
                <h3>Pro</h3>
                <p className="fs-2 fw-bold">
                  $149<span className="fs-5 fw-normal">/month</span>
                </p>
                <ul className="list-unstyled">
                  <li>All Basic Features</li>
                  <li>Advanced Notifications</li>
                  <li>Support Ticketing</li>
                  <li>Priority Support</li>
                  <li>Up to 25 Tenants</li>
                </ul>
                <Button color="primary" size="lg" className="mt-4">
                  <NavLink href="#tenant-request" className="text-white text-decoration-none">
                    Get Started
                  </NavLink>
                </Button>
              </CardBody>
            </Card>
          </Col>
          <Col md={4}>
            <Card className="pricing-card">
              <CardBody>
                <h3>Enterprise</h3>
                <p className="fs-2 fw-bold">Contact Us</p>
                <ul className="list-unstyled">
                  <li>All Pro Features</li>
                  <li>Audit Logging</li>
                  <li>Custom Integrations</li>
                  <li>24/7 Support</li>
                  <li>Unlimited Tenants</li>
                </ul>
                <Button color="primary" size="lg" className="mt-4">
                  Contact Sales
                </Button>
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Container className="text-center mt-5">
          <Accordion open={openAccordion} toggle={toggleAccordion}>
            <AccordionItem>
              <AccordionHeader targetId="1">How secure is my data?</AccordionHeader>
              <AccordionBody accordionId="1">
                We use AES-256 encryption, comply with GDPR and other global standards, and perform
                regular security audits to ensure your data is protected.
              </AccordionBody>
            </AccordionItem>
            <AccordionItem>
              <AccordionHeader targetId="2">
                How long does it take to onboard a new tenant?
              </AccordionHeader>
              <AccordionBody accordionId="2">
                Onboarding takes 1–3 days with our automated setup and dedicated support team
                assistance.
              </AccordionBody>
            </AccordionItem>
            <AccordionItem>
              <AccordionHeader targetId="3">
                Can I customize pricing plans for my tenants?
              </AccordionHeader>
              <AccordionBody accordionId="3">
                Yes, our platform allows you to create flexible pricing plans with monthly or yearly
                billing options, fully customizable via the dashboard.
              </AccordionBody>
            </AccordionItem>
            <AccordionItem>
              <AccordionHeader targetId="4">
                How does the support ticketing system work?
              </AccordionHeader>
              <AccordionBody accordionId="4">
                Our integrated ticketing system allows tenants to create, track, and resolve support
                tickets, with history and attachment support for efficient resolution.
              </AccordionBody>
            </AccordionItem>
            <AccordionItem>
              <AccordionHeader targetId="5">What support options are available?</AccordionHeader>
              <AccordionBody accordionId="5">
                Basic plans include email support, Pro plans offer priority support, and Enterprise
                plans provide 24/7 dedicated support with a personal account manager.
              </AccordionBody>
            </AccordionItem>
          </Accordion>
        </Container>
      </Container>
    </section>
  );
};

export default PricingSection;
